// Ringback tone generator — North-American cadence (2s on / 4s off, 440+480 Hz)
// Uses the Web Audio API so no audio asset is required. Best-effort: silently
// no-ops if the browser blocks audio until a user gesture.
export function createRingback() {
  let ctx = null, osc1 = null, osc2 = null, gain = null, interval = null, playing = false;

  const ring = () => {
    if (!ctx || !gain) return;
    const t = ctx.currentTime;
    try {
      gain.gain.cancelScheduledValues(t);
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.16, t + 0.04);
      gain.gain.setValueAtTime(0.16, t + 1.9);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 2.0);
    } catch { /* noop */ }
  };

  return {
    start() {
      if (playing) return;
      try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return;
        ctx = new AC();
        if (ctx.state === "suspended") ctx.resume().catch(() => {});
        osc1 = ctx.createOscillator();
        osc2 = ctx.createOscillator();
        gain = ctx.createGain();
        gain.gain.value = 0.0001;
        osc1.type = "sine"; osc2.type = "sine";
        osc1.frequency.value = 440; osc2.frequency.value = 480;
        osc1.connect(gain); osc2.connect(gain); gain.connect(ctx.destination);
        osc1.start(); osc2.start();
        playing = true;
        ring();
        interval = setInterval(ring, 6000);
      } catch { playing = false; }
    },
    stop() {
      playing = false;
      if (interval) { clearInterval(interval); interval = null; }
      try { osc1 && osc1.stop(); } catch { /* noop */ }
      try { osc2 && osc2.stop(); } catch { /* noop */ }
      try { ctx && ctx.close(); } catch { /* noop */ }
      ctx = osc1 = osc2 = gain = null;
    },
  };
}

// Incoming-call ringtone — a more urgent repeating double-beep (higher pitch).
export function createRingtone() {
  let ctx = null, osc = null, gain = null, interval = null, playing = false;
  const beep = () => {
    if (!ctx || !gain) return;
    const t = ctx.currentTime;
    try {
      gain.gain.cancelScheduledValues(t);
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.22, t + 0.03);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
      gain.gain.exponentialRampToValueAtTime(0.22, t + 0.5);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.85);
    } catch { /* noop */ }
  };
  return {
    start() {
      if (playing) return;
      try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return;
        ctx = new AC();
        if (ctx.state === "suspended") ctx.resume().catch(() => {});
        osc = ctx.createOscillator();
        gain = ctx.createGain();
        gain.gain.value = 0.0001;
        osc.type = "sine"; osc.frequency.value = 587;
        osc.connect(gain); gain.connect(ctx.destination);
        osc.start();
        playing = true;
        beep();
        interval = setInterval(beep, 2000);
      } catch { playing = false; }
    },
    stop() {
      playing = false;
      if (interval) { clearInterval(interval); interval = null; }
      try { osc && osc.stop(); } catch { /* noop */ }
      try { ctx && ctx.close(); } catch { /* noop */ }
      ctx = osc = gain = null;
    },
  };
}
